'use strict';

import React, { Children } from 'react';
import { buttonStyles } from './styles';
import PropTypes from 'prop-types';
import { constants } from '../../constants'
import cloneDeep from 'lodash/cloneDeep';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const _applyStyleModifiers = (props) => {
    const { 
        alignButton,
        backgroundColor,
        borderRadius,
        disabled,
        iconSize,
        play,
        text,
     } = props;

    const clonedStyles = cloneDeep(buttonStyles);
    
    const { 
        buttonStyle, 
        container, 
        buttonIconStyle 
    } = clonedStyles; 
    
    // Style Overrides

    buttonStyle.backgroundColor = (backgroundColor) ? backgroundColor : buttonStyle.backgroundColor;
    buttonStyle.cursor = (disabled) ? 'default' : 'pointer';
    buttonStyle.borderRadius = (borderRadius) ? borderRadius : buttonStyle.borderRadius;
    buttonStyle.alignItems = (alignButton) ? alignButton : buttonStyle.alignItems;
    container.justifyContent = (alignButton) ? alignButton : container.justifyContent;

    if(!text){
        (play) 
            ? buttonIconStyle.marginLeft = (iconSize / 1.9) || 10
            : buttonIconStyle.marginLeft = (iconSize / 2.4) || 10
        buttonIconStyle.marginRight = (iconSize / 2.4) || 10
        buttonIconStyle.paddingTop = (iconSize / 9) || 0
        buttonIconStyle.paddingBottom = (iconSize / 9) || 0
    }

    if (iconSize) {
        buttonIconStyle.fontSize = iconSize
    }

    return { ...clonedStyles, buttonStyle, container, buttonIconStyle };
}

export const Button = (props) => {
    
    const styles = _applyStyleModifiers(props);

    return (
        <div style={{...styles.container, ...props.style}}>
                <button type={props.type} style={ styles.buttonStyle } onClick={props.onClick}>
                    {props.iconName && 
                        <FontAwesomeIcon 
                            icon={['fas', props.iconName]}
                            style={ {...styles.buttonIconStyle, fontSize: props.iconSize} }
                        />
                    }
                    {props.children && <span style={styles.textStyle}>{props.children}</span>}
                    {props.text && props.text}
                    { /*React.Children.map(this.props.children, (child, i)=>{
                        return React.cloneElement(child, {
                            style: this.props.name
                        })
                    })} */}
                </button>
        </div>
    );
};

Button.defaultProps = {
    backgroundColor: constants.color.secondary || '#000000',
    borderRadius: 0,
    onClick: () => { 
        // console.log('Button Clicked') 
    },
    play: false, // this is used to adjust for optical centering of play icon
    style: {},
    type: '',
}

Button.propTypes = {
    backgroundColor: PropTypes.string,
    borderRadius: PropTypes.number,
    iconName: PropTypes.string,
    iconSize: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    play: PropTypes.bool,
    style: PropTypes.object,
    text: PropTypes.string,
    textColor: PropTypes.string,
    type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/js/components/Button/Button.jsx